import React from "react";
import { Checkbox } from "antd";
import { useController } from "react-hook-form";

const getCheckedValue = fieldValue => {
  if (typeof fieldValue === "boolean") return fieldValue;
  if (fieldValue === "1") return true;
  if (fieldValue === "0") return false;
  return !!fieldValue;
};

export const CheckboxFormField = ({
  label,
  error,
  size,
  suffix,
  control,
  name,
  onChange,
  defaultValue,
  className = "",
  ...rest
}) => {
  const { field, fieldState } = useController({
    control,
    name,
    ...(defaultValue !== undefined && { defaultValue })
  });

  return (
    <div className="hook-form-checkbox">
      <div
        className={`form-field-wrapper row  ${className}`}
      >
        <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
          <Checkbox
            {...rest}
            {...field}
            checked={getCheckedValue(field.value)}
            onChange={e => {
              field.onChange(e);
              if (onChange) {
                onChange(e);
              }
            }}
          >
            {label}
          </Checkbox>
          {fieldState?.error?.message && (
            <div className="form-field-error col-12">
              {fieldState.error.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
